//==========import components===============
import TitleSection from 'components/common/TitleSection';
import SubPagesLayout from 'layouts/SubPagesLayout';
import { detailData } from 'helpers/portfolioHelper';

const EventDetail = () => {
  const titleDetail = {
    upperTitle: '',
    middleTitle: 'EVENTS ALL ALBUM',
    lowerTitle: '',
  };
  return (
    <section className='eventDetailSec DBlock py-10 sm:py-12 px-6 sm:px-10'>
      <div className='max-w-7xl mx-auto'>
        <div className=' grid grid-cols-1 lg:grid-cols-2 gap-6 relative z-1'>
          <div>
            <h2 className='sm:text-lg text-base font-semibold text-eventLightYellow uppercase pb-2'>
              ABOUT de evente
            </h2>
            <h1 className='sm:text-3xl text-lg xl:text-5xl uppercase font-bold'>
              Trusted by 20,000+ People
            </h1>
            <p className='text-sm sm:text-base text-eventGray py-4'>
              We specialize in not only planning and hosting extravagant and
              large events but also have diverse experience in producing ideas
              and managing intimate yet beautiful gatherings too! All your
              weddings, engagement parties, and beautiful receptions are all
              entertained at Mahara with intricate detail to make your event
              wholesome, memorable, and overall PERFECT! Our team of
              professionals is trained to meet the expectations of our clients
              through and through. We make sure our clients are dealt with
              class, professionalism, and compassion. After all, “A HUMAN NEVER
              REMEMBERS
            </p>
            <div className='grid grid-cols-1 lg:grid-cols-2 gap-4'>
              <div>
                <h2 className='font-bold text-sm text-black pr-1 sm:inline-block block'>
                  Venu:
                </h2>
                <p className='text-eventGray font-normal text-md'>
                  4 Shannan Road,GOR 1 Lahore, Pakistan
                </p>
              </div>
              <div>
                <h2 className='font-bold text-sm text-black pr-1 sm:inline-block block'>
                  Date:
                </h2>
                <p className='text-eventGray font-normal text-sm'>04-09-2022</p>
              </div>
            </div>
          </div>
          <div>
            <img
              src='/assets/images/portfolio/privateBirthdayParty/mayon/2.png'
              alt='eventImg'
            />
          </div>
        </div>
        <div className='grid grid-cols-1 pt-12'>
          <TitleSection titleDetail={titleDetail} />
          <div className='grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 '>
            {detailData?.map((portfoilo, ind) => (
              <div
                className='flex flex-col items-center sm:block'
                key={`portfoilo${ind}`}
              >
                <img
                  src={`${portfoilo?.image}`}
                  alt='portfolioImg'
                  className='w-full h-auto'
                />
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default SubPagesLayout({ route: 'Portfolio / CORPORATIVE EVENTS' })(
  EventDetail
);
